<div class="permissions-alert">
  <figure>
    <img class="" src="assets/images/arrow-up.svg" alt="Flecha arriba"/>
  </figure>
  <span>{{'recallPermissions' | translate}}</span>
</div>
